export default {"src":"/_next/static/media/logo.e7cd1e88.svg","height":20,"width":102,"blurWidth":0,"blurHeight":0};